// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2YOhZ","item":"PaymentsMobile_item__2oTPF","label":"PaymentsMobile_label__2m-fa","amount":"PaymentsMobile_amount__1f0G4"};